module.exports = __webpack_public_path__ + "static/media/RX Max-en.f0cf7828.jpg";